import React, { useState } from 'react';
//import CalendarMonthView from 'react-calendar-month-view';

const Calendar = () => {
    /*const renderDay = (date, isSmallCalendar) => {
        return <div>{date.getDate()}</div>;
    };
    
    const handleClickDay = (date) => {
        console.log(date);
    };*/

    return (

    <div>CalendarPage</div>
      
    );
  };
export default Calendar